import {Component, EventEmitter, Input, Output} from '@angular/core';

import {ButtonListQuestionType} from 'shared/models/questions/button-list-question-type';
import {TranslatedText} from 'shared/models/translated-text';

@Component({
  selector: 'type-button-list',
  templateUrl: './type-button-list.component.html',
  styleUrls: ['./type-button-list.component.css'],
})
export class TypeButtonListComponent {

  @Input() public language: string;
  @Input() public data: ButtonListQuestionType;
  @Input() public inChains: Array<string>;
  @Input() public isSystemQuestion: boolean;
  @Input() public isChainSystemEditable: boolean = false;
  @Output() public dataChange: EventEmitter<ButtonListQuestionType>;

  public oldButtonCount: number = null;

  constructor() {
    this.data = new ButtonListQuestionType();
    this.dataChange = new EventEmitter<ButtonListQuestionType>();
  }

  public addButton(): void {
    if (this.oldButtonCount === null) {
      this.oldButtonCount = this.data.buttons.length;
    }
    this.data.buttons.push(TranslatedText.createEmptyInstance());
    this.dataChange.emit(this.data);
  }

  public deleteButton(index: number): void {
    this.data.buttons.splice(index, 1);
    this.dataChange.emit(this.data);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-details/type-components/type-button-list/type-button-list.component.ts